import { Offer } from './offer.model';
import { PricingOption } from './pricing-option.model';
import { OfferVehicleView } from './offer-vehicle.model';

export class OfferViewDTO extends Offer {
  public pricingOptions?: PricingOption[] = [];
  public deletable?: boolean;
  public minQuantity?: number;
  public maxQuantity?: number;
  public handlingTypes?: string[] = [];
  public offerVehicles?: OfferVehicleView[];

  constructor(data: any = {}) {
    super(data);
    this.deletable = data.deletable;
    this.minQuantity = data.minQuantity;
    this.maxQuantity = data.maxQuantity;
    this.handlingTypes = data.handlingTypes;
    this.pricingOptions = data.pricingOptions ? data.pricingOptions.map((val: any) => new PricingOption(val)) : [];
    this.offerVehicles = data.offerVehicles ? data.offerVehicles.map((val: any) => new OfferVehicleView(val)) : [];
  }

  override serialize(): any {
    const baseSerialization = super.serialize();
    return {
      ...baseSerialization,
      deletable: this.deletable,
      minQuantity: this.minQuantity,
      maxQuantity: this.maxQuantity,
      handlingTypes: this.handlingTypes,
      pricingOptions: (this.pricingOptions || []).map(val => val.serialize()),
      offerVehicles: (this.offerVehicles || []).map(val => val.serialize()),
    };
  }
}
